import gaTable from "@/assets/js/utils/gaFormator";
import { detectPlatform } from "@/assets/js/utils/udn-newmedia-utils";
function detectDevice(w) {
  switch (true) {
    case (w < 767.98):
      return 'mob';          
    case (768 <= w && w <= 1024.98):
      return 'pad';
    default:
      return 'pc';
  }
}
const selectSrcMethod_3 = {
  methods: {
    selectSrc_3: function(mob, pad, pc) {
      const w = window.innerWidth;
      const deviceType = detectDevice(w);
      switch (deviceType) {
        case 'mob':
          return mob;
        case 'pad':
          return pad;    
        default:
          return pc;
      }
    },
    selectSrc_2: function(mob, pc) {
      const w = window.innerWidth;
      const deviceType = detectDevice(w);
      switch (deviceType) {
        case 'mob':
          return mob;   
        default:
          return pc;
      }
    },
  },
}

const sendGaMethods = {
  methods: {
    sendGA: function(item) {
      /**
       * item = {
       *   category: ...
       *   action: ...
       *   label: ...
       * }
       */
      ga("newmedia.send", {
        hitType: "event",
        eventCategory: item.category,
        eventAction: item.action,
        eventLabel:
          "[" +
          detectPlatform() +
          "] [" +
          document.querySelector("title").innerHTML +
          "] [" +
          item.label +
          "]",
      });
    },
    sendUDNGA: function(item) {
      window.ga("udn.send", {
        hitType: "event",
        eventCategory: item.category,
        eventAction: item.action,
        eventLabel:
          "[" +
          detectPlatform() +
          "] [" +
          document.querySelector("title").innerHTML +
          "] [" +
          item.label +
          "]",
      });
    },
    formatGA: function(name) {
      return gaTable[name];
    },
  },
};

export {
  selectSrcMethod_3,
  sendGaMethods,
};